import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

export const updateOrder = async (orderId, locationId, items) => {
  const { token, userID } = useCurrentUser();
  const apiURL = `${API_HOST}/orders/update_order`;
  // console.log('here is apiURL in updateOrder: ', apiURL);

  // console.log('checkout token in updateOrder: ', token);
  // console.log('1234 look at this items: ', items);
  const orderDetails = {
    order_id: orderId,
    location_id: locationId,
    items: Array.isArray(items)
      ? items.map((item) => ({
          store_item_id: item.store_item_id,
          quantity: item.quantity,
        }))
      : [],
  };

  // console.log('here is the orderDetails: ', orderDetails);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'x-dqpn-user-id': userID,
  };

  // console.log('Headers:', headers);

  try {
    const response = await axios.put(apiURL, orderDetails, { headers });
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Exception occurred while updating order:', error.message);
    return { success: false, error: error.message };
  }
};

// const orderId = 29608;
// const locationId = 123;
// const items = [
//   { storeItemId: 3378, quantity: 14 }
// ];

// updateOrder(orderId, locationId, items);
